<template>
  <div>
    <slot name="info" />

    <NotAvailableMessage
      v-if="notAvailableType"
      :not-available-type="notAvailableType"
      :company-uuid="companyUuid"
      :is-more-than-editor="isMoreThanEditor"
    />

    <div v-if="!notAvailableType" class="p-box">
      <div class="p-box__header" :class="{ competitorView: isCompetitorView }">
        <slot name="header" />
      </div>

      <div class="p-box__body" :class="{ competitorView: isCompetitorView }">
        <slot name="overview" />

        <slot name="graph" />

        <!-- 分析条件のやつ -->
        <slot name="terms" />

        <slot name="competitor" />

        <slot name="reset" />

        <slot name="list" />

        <div class="p-table">
          <div class="p-table__content">
            <slot name="table" />
          </div>
        </div>
        <slot name="reviews" />
        <slot name="filter" />
        <slot name="paginator" />
      </div>
    </div>
  </div>
</template>

<script>
import NotAvailableMessage from '../components/NotAvailableMessage'

export default {
  name: 'CompaniesAnalysisLayout',
  components: {
    NotAvailableMessage,
  },
  props: {
    notAvailableType: {
      type: String,
      required: false,
    },
    companyUuid: {
      type: String,
      required: true,
    },
    isCompetitorView: {
      type: Boolean,
      default: false,
    },
    isMoreThanEditor: {
      type: Boolean,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';

.p-box__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
  }

  .c-links {
    flex-wrap: nowrap;
    width: 100%;
    overflow: scroll hidden;

    button {
      color: #E9446A;

      &.is-active {
        color: #3A3B3F;
      }

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .date-range-picker {
    margin: 0 0 0 16px;
    min-width: 276px;
  }

  .date-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 768px) {
      margin-bottom: 16px;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      .c-switch,
      .c-select {
        margin: 0 0 16px 0;
      }
    }
  }
}

.competitorView {
  background-color: $color-competitor-bg;
}

.p-table__content {
  overflow-x: visible;
}
</style>
